const formatDate = (isoDate) =>
  new Date(isoDate).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });

const formatAmount = (amount, currency) => (currency ? `${amount} ${currency}` : `${amount}`);

const pluralize = (count, singular, plural) => `${count} ${count === 1 ? singular : plural}`;

const describeValue = (config, currency) => {
  if (config.type === 'percentage') {
    return `${config.value}% off`;
  }
  if (config.type === 'fixedAmount') {
    return `${formatAmount(config.value, currency)} off`;
  }
  const maximumShippingRate =
    config.value !== null && config.value !== undefined ? ` up to ${formatAmount(config.value, currency)}` : '';
  return `Free shipping${maximumShippingRate}`;
};

const describeTarget = (config) => {
  if (config.type === 'freeShipping') {
    const countryCodes = config.countries?.all === false ? config.countries.codes || [] : [];
    return countryCodes.length > 0 ? `to ${countryCodes.join(', ')}` : 'to all countries';
  }
  const ids = config.appliesTo?.ids || [];
  if (config.appliesTo?.kind === 'products') {
    return pluralize(ids.length, 'product', 'products');
  }
  if (config.appliesTo?.kind === 'collections') {
    return `products in ${pluralize(ids.length, 'collection', 'collections')}`;
  }
  return 'any order';
};

const describeMinimum = (minimumPurchase, currency) => {
  if (minimumPurchase?.kind === 'subtotal') {
    return `minimum purchase of ${formatAmount(minimumPurchase.value, currency)}`;
  }
  if (minimumPurchase?.kind === 'quantity') {
    return `minimum ${pluralize(minimumPurchase.value, 'item', 'items')}`;
  }
  return null;
};

const describeActivation = (activation) => {
  if (activation?.kind === 'date' && activation.date) {
    return `starts ${formatDate(activation.date)}`;
  }
  return null;
};

const describeExpiration = (expiration) => {
  if (expiration?.kind === 'date' && expiration.date) {
    return `expires ${formatDate(expiration.date)}`;
  }
  if (expiration?.kind === 'afterDuration') {
    const durationParts = [];
    if (expiration.days) {
      durationParts.push(pluralize(expiration.days, 'day', 'days'));
    }
    if (expiration.hours) {
      durationParts.push(pluralize(expiration.hours, 'hour', 'hours'));
    }
    return durationParts.length > 0 ? `expires ${durationParts.join(' ')} after send` : null;
  }
  return 'expires 1 year after send';
};

const describeDiscount = (config, { currency } = {}) => {
  if (!config) {
    return '';
  }
  const headline = `${describeValue(config, currency)} ${describeTarget(config)}`;
  const details = [
    describeMinimum(config.minimumPurchase, currency),
    describeActivation(config.activation),
    describeExpiration(config.expiration),
  ];
  const clauses = [headline];
  for (const detail of details) {
    if (detail) {
      clauses.push(detail);
    }
  }
  return clauses.join(', ');
};

export default describeDiscount;
